<template>
  <div class="block news__card">
    <figure>
      <img v-if="news.img" :src="news.img" />
      <img v-else src="@/assets/img/default-news.png" />
      <figcaption>
        <span class="post__date"> {{ dateParse.parseShortDate(news) }} </span>
        <h2>
          {{ news.title }}
        </h2>
        <span v-if="newsTag" class="news-tag">{{ newsTag }}</span>
      </figcaption>
    </figure>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";

import dateParse from "@/helpers/date";

const props = defineProps({
  news: Object,
});

const newsTag = computed(() => {
  if (props.news.options) {
    let options = JSON.parse(props.news.options);

    return options.tag ? options.tag : null;
  }

  return null;
});
</script>
